export default {
      id: "menu-lines-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "img/icons.svg#menu-lines",
      toString: function () {
        return this.url;
      }
    }